"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _statusModule = _interopRequireDefault(require("./status.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function NameWorkflow(props) {
  var data = props.data,
    onClick = props.onClick;
  var val = data === null || data === void 0 ? void 0 : data.split('_');
  var workflow = 'live';
  if (val[0] === "draft") {
    workflow = "draft";
  } else if (val[0] === "stage") {
    workflow = "stage";
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _statusModule["default"].common
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: onClick && onClick,
    className: "".concat(_statusModule["default"].wrapper, " ").concat(_statusModule["default"]["_" + workflow])
  }, workflow));
}
var _default = NameWorkflow;
exports["default"] = _default;